<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app" class="my-0 py-0">
            <v-app id="inspire">
                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                    <v-card v-model="show" class="py-0">
                        <v-toolbar class="py-0 my-0" dark color="blue">
                            <v-toolbar-title class="my-0 py-0">Editar portal</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="show = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                    </v-card>
                    <v-card color="blue lighten-4">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="12" sm="12" md="4">
                                    <v-text-field label="Empresa" dense v-model="empresa">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="8">
                                    <v-text-field label="Link" dense v-model="link">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="6" sm="4" md="3">
                                    <v-text-field required :rules="requiredRules" label="Fecha de Actualización:" dense
                                        v-model="fecha"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="2" md="3">
                                    <v-text-field required :rules="requiredRules" label="Usuario:" dense
                                        v-model="usuario"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="4" md="3">
                                    <v-text-field label="Contraseña:" dense v-model="password"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12" md="6">
                                    <v-textarea label="Observaciones:" auto-grow rows="2" dense
                                        v-model="observ"></v-textarea>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card color="blue" dark tile>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" @click.stop="guardar" :disabled="deshabilitar">Guardar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-app>
        </div>
    </v-dialog>
</template>

<script>
import moment from "moment";
import axios from "../../axios-auth";
export default {
    data: (vm) => ({
        usuario: "",
        codgral: "",
        valid: false,
        validsubir: false,
        deshabilitar: false,
        lazy: false,
        requiredRules: [(v) => !!v || "Dato obligatorio"],
        empresa: "",
        usuario: "",
        link: "",
        password: "",
        fecha: moment().format("DD/MM/YYYY"),
        observ: "",
    }),
    props: ["visible", "id"],
    computed: {
        show: {
            get() {
                if (this.visible == true) {
                    this.cargardatos();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        vaciarModels() {
            this.empresa = "";
            this.link = "";
            this.usuario = "";
            this.password = "";
            this.observ = "";
            this.fecha = moment().format("DD/MM/YYYY");
        },

        cargardatos() {
            const id = this.id;
            let self = this;
            axios
                .get("/Comercial/CargarPortal?", {
                    params: {
                        id: id,
                    },
                })
                .then((response) => {
                    self.fecha = response.data.fecha;
                    self.empresa = response.data.empresa;
                    self.link = response.data.link;
                    self.usuario = response.data.usuario;
                    self.password = response.data.password;
                    self.observ = response.data.observ;
                })
                .catch((error) => {

                    console.log(error);
                });
        },
        guardar() {
            this.$swal({
                title: "Guardar Portal",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    this.deshabilitar = true;
                    var datos = {
                        id: this.id,
                        link: this.link,
                        empresa: this.empresa,
                        usuario: this.usuario,
                        password: this.password,
                        fecha: this.fecha,
                        observ: this.observ,
                    };
                    let self = this;
                    axios
                        .post("/Comercial/EditarPortal", datos)
                        .then((response) => {
                            self.showAlert({
                                icon: "success",
                                title: self.mensaje,
                                vm: self,
                            });
                            self.vaciarModels();
                            self.$emit("close");
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            });
        },
        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 5000,
            });
        },
    },
};
</script>
